module.exports = __webpack_public_path__ + "static/media/ondes3.f70d987a.mp3";